<template>
  <select
    class="form-control m-input"
    @select="emitChangeEvent"
    @change="emitChangeEvent"
  >
    <option v-if="firstOption !== null" value="">{{ firstOption }}</option>
    <option
      v-for="status in selects"
      :key="status.id"
      :value="status.id"
      :selected="status.id === selected"
    >
      {{ status.name }}
    </option>
  </select>
</template>

<script>
export default {
  name: 'SelectYesNo',
  data() {
    return {
      selects: [],
      firstOption: this.first ? this.first : 'Todos',
    };
  },
  props: {
    selected: {
      type: [Number, String],
    },
    first: {
      type: String,
    },
    bool: {
      type: Boolean,
    },
  },
  methods: {
    getData() {
      this.selects = [
        { id: '1', name: 'Sim' },
        { id: '2', name: 'Não' },
      ];

      if (this.bool) {
        this.selects[1].id = 0;
      }
    },
    emitChangeEvent(variable) {
      this.$emit('change', variable.target.value);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
